// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 4316 ? "ad2866b8" : chunkId) + "." + {"4316":"d85b767868b3371e","4548":"70d8c392bd00cbfd","5268":"489cecef701ce154","8292":"d0190eccaa2a88aa"}[chunkId] + ".js";
};